module.exports = __webpack_public_path__ + "img/setting-icon-active.0649e2b6.png";